<template>
  <fragment>
    <!-- 데이터 테이블 -->
    <PagingTable ref="table" :sourceList="tableItems">
      <template #header>
        <caption>
          <span class="blind">대상자별 반복/맞춤소식 목록</span>
        </caption>
        <colgroup>
          <col width="5%" />
          <col width="10%" />
          <!-- <col width="18%" /> -->
          <col />
          <col width="8%" />
          <col width="10%" />
          <col width="10%" />
          <col width="8%" />
        </colgroup>
        <thead class="table_list_head">
          <tr>
            <th data-sort="id">번호</th>
            <th class="center" data-sort="newsType,customNewsType">소식종류</th>
            <!-- <th class="center" data-sort="rcpDesc">받는사람</th> -->
            <th class="center" data-sort="boardContent">소식 내용</th>
            <th class="center" data-sort="userName">작성자</th>
            <th class="center" data-sort="validFrom">유효기간</th>
            <th class="center" data-sort="reserveTime">예약시간</th>
            <th class="center" data-sort="repeatStrategy.period,repeatStrategy.dayOfWeek">전송주기</th>
          </tr>
        </thead>
      </template>

      <template #row="{ rowData }">
        <tr>
          <td>{{rowData.id}}</td>
          <RepeatTypeTextColumn
            :newsType="rowData.newsType"
            :customNewsType="rowData.customNewsType"
            :short="true"
          />
          <!-- <td>
            <button
              type="button"
              class="link_modal"
              @click="openRepeatSendLogsByRowData(rowData)"
            >{{rowData.rcpDesc}}</button>
          </td>-->
          <EditedTextColumn
            :value="rowData.boardContent"
            :rowData="rowData"
            :maxLength="60"
            @click="openRepeatDetail({ newsId: rowData.id })"
          />
          <td>{{rowData.userName}}</td>
          <PeriodColumn :start="rowData.validFrom" :end="rowData.validTo" />
          <RepeatReserveTimeColumn :rowData="rowData" />
          <RepeatStrategyColumn :value="rowData.repeatStrategy" />
        </tr>
      </template>
    </PagingTable>

    <!-- 버튼 영역 -->
    <div class="section_button">
      <ExcelDownloadButton v-if="res" :filename="$utils.excelName('반복맞춤소식', res.rcpName)">
        <ExcelTable :sourceList="tableItems" />
      </ExcelDownloadButton>
      <HelpButton contentId="HELP_01" />
    </div>
  </fragment>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import ExcelTable from "./excelTables/Recipient.repeat.total";

export default {
  mixins: [newsMixin],
  components: {
    ExcelTable
  },
  props: {
    rcpId: String,
    registerType: String
  },
  data() {
    return {
      res: null
    };
  },
  computed: {
    tableItems() {
      if (!this.res) return null;
      return this.res.boardList;
    }
  },
  methods: {
    requestOptions() {
      return { params: { searchNewsType: this.registerType } };
    },
    loadData(keepTableState) {
      const options = this.requestOptions();
      this.$axios
        .get(`/admin/v2/news/repeat/rcp/${this.rcpId}`, options)
        .then(({ data }) => {
          this.res = data.data;
          this.$emit("dataLoaded", this.res);
          if (!keepTableState && this.$refs.table)
            this.$refs.table.resetState();
        });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
